import { BooleanInput } from '@angular/cdk/coercion';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { MatSnackBar } from '@angular/material/snack-bar'
import { AuthService } from 'app/core/auth/auth.service';

@Component({
	selector: 'user',
	templateUrl: './user.component.html',
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
	exportAs: 'user',
	standalone: true,
	imports: [
		MatButtonModule,
		MatMenuModule,
		MatIconModule,
		MatDividerModule,
		MatSnackBarModule
	],
})
export class UserComponent implements OnInit, OnDestroy {
	// Para coerción booleana
	static ngAcceptInputType_showImage: BooleanInput;

	// Inputs
	@Input() showImage = true;

	// Usuario actual
	user: User;

	// Para cancelar suscripciones
	private readonly _unsubscribeAll = new Subject<void>();
	private _snackBar = inject(MatSnackBar);

	constructor(
		private readonly _cdr: ChangeDetectorRef,
		private readonly _router: Router,
		private readonly _userService: UserService,
		private _authService: AuthService,
	) {}

	ngOnInit(): void {
		this._userService.user$
			.pipe(takeUntil(this._unsubscribeAll))
			.subscribe((user: User) => {
				if(!user?.name || !user?.email || !user?.image){
					user = this._userService.authenticatedUser;
				}
				this.user = user;
				this._cdr.markForCheck();
			});
	}

	ngOnDestroy(): void {
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}

	//cierre de sesion
	signOut(): void{
		this._authService.signOut().subscribe({
			next: (res) => {
				//Redirigue automaticamente al inicio de sesion
				this._router.navigate(['sign-in']);
				this.openSnackBar('Ha concluido su sesión.', true);
			}
		});
	}
	//Mensaje
	openSnackBar(message: string, isSuccess: boolean): void {
		this._snackBar.open(message, '', {
		  horizontalPosition: 'right',
		  verticalPosition: 'top',
		  duration: 1000,
		  panelClass: [isSuccess ? 'success-snackbar' : 'error-snackbar', 'center-text-snackbar'],
		});
	  }

	/**
	 * Redirecciona al perfil
	 */
	goToProfile(): void {
		this._router.navigate(['/profile']);
	}
}
